/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Nav_ContentInputs */

const en_admin_nav_content = /** @type {(inputs: Admin_Nav_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

const zh_admin_nav_content = /** @type {(inputs: Admin_Nav_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容管理`)
};

/**
* | output |
* | --- |
* | "Content" |
*
* @param {Admin_Nav_ContentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_nav_content = /** @type {((inputs?: Admin_Nav_ContentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Nav_ContentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_nav_content(inputs)
	return zh_admin_nav_content(inputs)
});
export { admin_nav_content as "admin.nav.content" }